import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { type PayCard } from '@webapp/models'
import { PayCardStatuses } from '@webapp/models/enums'
import messages from './messages'

export interface SpendingCardManagementDetailsPageParams {
  card: PayCard['external_id']
}

const SpendingCardManagementDetailsViewChunk = lazy(() =>
  import('../containers/SpendingCardManagementDetailsView').then(
    ({ SpendingCardManagementDetailsView }) => ({
      default: SpendingCardManagementDetailsView,
    })
  )
)

export const SpendingCardManagementDetailsPage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.spendingCardManagementTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.spendingCardManagementTitle),
          link: url('CardManagementPage', {
            status: PayCardStatuses.ACTIVE,
          }),
        },
        {
          name: intl.formatMessage(
            messages.spendingCardManagementDetailsPageTitle
          ),
        },
      ]}
    >
      <SpendingCardManagementDetailsViewChunk />
    </Page>
  )
}
